import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  constructor(private http: HttpClient) { }

  getCategorie(lingua): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + 'public/faq/cat/' + lingua + '/')
      .pipe(map(response => {
        return response;
      }));
  }
  getFaq(idcategoria, lingua): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + 'public/faq/faq/' + idcategoria + '/' + lingua + '/')
      .pipe(map(response => {
        return response;
      }));
  }

}
